function formatMoney(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount / 100);
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/* ==========================================================
  FREE GIFT CLEANUP CONFIG

  Cambia estos handles por los reales de tu tienda.
  El handle es lo que aparece después de /products/ en la URL.

  Ejemplo:
  /products/pistola-de-agua-electrica
  handle = pistola-de-agua-electrica

  Puedes usar handles, product IDs o variant IDs.
========================================================== */

const FREE_GIFT_RULES = {
  mainProductHandles: ["almohadillas"],
  mainProductIds: [],
  mainVariantIds: [],

  giftProductHandles: ["ebook", "garantia"],
  giftProductIds: [],
  giftVariantIds: [],
};

function normalizeGiftRuleValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^\/products\//, "")
    .replace(/^https?:\/\/[^/]+\/products\//, "")
    .split("?")[0]
    .replace(/\/$/, "");
}

function getCartItemHandle(item) {
  if (item.handle) return normalizeGiftRuleValue(item.handle);
  if (item.product_handle) return normalizeGiftRuleValue(item.product_handle);
  if (item.url) return normalizeGiftRuleValue(item.url.split("/products/")[1]);
  return "";
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isCartUpdating = false;
    this.isGiftSyncing = false;
    this.syncFreeGiftsDebounced = debounce(
      this.syncFreeGiftsWithMainProduct.bind(this),
      30
    );

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.cartDrawer = this.querySelector(".drawer__inner");

    this.cartDrawer.addEventListener(
      "click",
      this.handleGiftAwareRemoveClick.bind(this),
      true
    );

    this.cartDrawer.addEventListener(
      "click",
      this.handleCartDrawerClick.bind(this)
    );
    this.updateCartDebounced = debounce(this.updateCart.bind(this), 100);
    this.initializeUpsellButtons(); // Ensure upsell buttons are initialized at the start
    this.initializeVariantSelectors();
    this.syncFreeGiftsDebounced();
  }

  // Ensure upsell buttons are initialized on cart drawer open and update
  initializeUpsellButtons() {
    console.log("initialize upsell buttons...");

    var upsellAddButtons = this.querySelectorAll(".upsell-add-button");

    upsellAddButtons.forEach((button) => {
      button.removeEventListener("click", this.handleUpsellButtonClick);
      button.addEventListener("click", this.handleUpsellButtonClick.bind(this));
    });
  }

  initializeVariantSelectors() {
    const variantSelectors = this.querySelectorAll('.upsell-product__variant-selector');
    
    variantSelectors.forEach(selector => {
      selector.removeEventListener('change', this.handleVariantChange);
      selector.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }

  handleVariantChange(event) {
    const selector = event.target;
    const productId = selector.getAttribute('data-product-id');
    const selectedOption = selector.options[selector.selectedIndex];
    const productContainer = selector.closest('.upsell-product');
    const productImage = productContainer.querySelector('.upsell-product-image');

    const imageUrl = selectedOption.getAttribute('data-image-url');
    const defaultImage = productImage.getAttribute('data-default-image'); // Get the default image

    // Check if the imageUrl is not empty and does not contain 'no-image'
    if (imageUrl && !imageUrl.includes('no-image')) {
        productImage.src = imageUrl;
    } else {
        productImage.src = defaultImage;
    }





    
    // Update the add button or checkbox with the new variant ID
    const addButton = productContainer.querySelector('.upsell-add-button');
    const checkbox = productContainer.querySelector('.upsell-checkbox');
    
    if (addButton) {
      addButton.setAttribute('data-product-id', selector.value);
    }
    
    if (checkbox) {
      checkbox.setAttribute('data-product-id', selector.value);
      checkbox.id = `upsell-product-${selector.value}`;
    }
  }

  // Updated handleUpsellButtonClick method to call addProductToCart with isUpsell flag
  handleUpsellButtonClick(event) {
    event.stopPropagation();

    var button = event.target;
    var productId = button.getAttribute("data-product-id");
    var variantSelector = button
      .closest(".upsell-product")
      .querySelector(".upsell-product__variant-selector");
    var variantId = variantSelector ? variantSelector.value : null;

    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }

    this.addProductToCart(productId, variantId, true);
  }

  handleCartDrawerClick(event) {
    console.log("handleCartDrawerClick");

    const quantityButton = event.target.closest(".quantity__button");
    const removeButton = event.target.closest(".cart-remove-button");

    if (quantityButton || removeButton) {
      setTimeout(() => {
        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
        this.syncFreeGiftsDebounced();
      }, 150);
    }
  }

  handleUpsellChange(event) {
    var checkbox = event.target;
    var productId = checkbox.getAttribute("data-product-id");
    var variantSelector = checkbox
      .closest(".upsell-product")
      .querySelector(".upsell-product__variant-selector");
    var variantId = variantSelector ? variantSelector.value : null;

    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }

    if (checkbox.checked) {
      this.addProductToCart(productId, variantId);
    } else {
      this.removeProductFromCart(productId);
    }
  }

  getCartItemRows() {
    return Array.from(this.querySelectorAll("tr.cart-item[data-line-key]"));
  }

  getCartItemDataFromRow(row) {
    if (!row) return null;

    return {
      key: row.getAttribute("data-line-key"),
      handle: row.getAttribute("data-product-handle"),
      product_handle: row.getAttribute("data-product-handle"),
      product_id: Number(row.getAttribute("data-product-id")),
      variant_id: Number(row.getAttribute("data-variant-id")),
    };
  }

  isMainCartRow(row) {
    const item = this.getCartItemDataFromRow(row);
    return item ? this.isMainCartItem(item) : false;
  }

  isGiftCartRow(row) {
    const item = this.getCartItemDataFromRow(row);
    return item ? this.isGiftCartItem(item) : false;
  }

  removeRowsInstantly(rowsToRemove) {
    rowsToRemove.forEach((row) => {
      if (!row) return;
      row.style.transition = "opacity 120ms ease, transform 120ms ease";
      row.style.opacity = "0";
      row.style.transform = "translateX(8px)";
      setTimeout(() => row.remove(), 120);
    });
  }

  showInstantEmptyCartView() {
    this.toggleEmptyCartView(true);

    const cartDrawerItems = this.querySelector("cart-drawer-items");

    if (cartDrawerItems) {
      cartDrawerItems.innerHTML = `
        <div class="drawer__inner-empty">
          <div class="cart-drawer__warnings center">
            <div class="cart-drawer__empty-content">
              <h2 class="cart__empty-text">Your cart is empty</h2>
              <button
                class="drawer__close"
                type="button"
                onclick="this.closest('cart-drawer').close()"
                aria-label="Close"
              >
                ×
              </button>
              <a href="/collections/all" class="button">
                Continue shopping
              </a>
            </div>
          </div>
        </div>
      `;
    }
  }

  async handleGiftAwareRemoveClick(event) {
    const removeButton = event.target.closest(".cart-remove-button");

    if (!removeButton) return;

    const itemRow = removeButton.closest("tr.cart-item[data-line-key]");

    if (!itemRow) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    removeButton.setAttribute("disabled", "disabled");
    removeButton.style.pointerEvents = "none";
    removeButton.style.opacity = "0.45";

    try {
      await this.removeCartItemAndRelatedGifts(itemRow);
    } catch (error) {
      console.error("Error handling gift-aware remove click:", error);
      removeButton.removeAttribute("disabled");
      removeButton.style.pointerEvents = "";
      removeButton.style.opacity = "";
      this.updateCart();
    }
  }

  async removeCartItemAndRelatedGifts(itemRowToRemove) {
    if (this.isGiftSyncing) return;

    this.isGiftSyncing = true;
    this.isCartUpdating = true;

    const allRows = this.getCartItemRows();
    const itemToRemove = this.getCartItemDataFromRow(itemRowToRemove);

    if (!itemToRemove?.key) {
      this.isGiftSyncing = false;
      this.isCartUpdating = false;
      return;
    }

    const itemToRemoveIsMainProduct = this.isMainCartItem(itemToRemove);

    const anotherMainProductWillRemain = allRows.some((row) => {
      return row !== itemRowToRemove && this.isMainCartRow(row);
    });

    const rowsToRemove = [itemRowToRemove];

    if (itemToRemoveIsMainProduct && !anotherMainProductWillRemain) {
      allRows.forEach((row) => {
        if (row !== itemRowToRemove && this.isGiftCartRow(row)) {
          rowsToRemove.push(row);
        }
      });
    }

    const updates = {};

    rowsToRemove.forEach((row) => {
      const item = this.getCartItemDataFromRow(row);
      if (item?.key) {
        updates[item.key] = 0;
      }
    });

    const remainingRows = allRows.filter((row) => !rowsToRemove.includes(row));

    this.removeRowsInstantly(rowsToRemove);

    if (remainingRows.length === 0) {
      this.showInstantEmptyCartView();
    }

    try {
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (!updateResponse.ok) {
        throw new Error("Failed to remove cart item and related gifts");
      }

      this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));

      setTimeout(() => {
        this.updateCart();
      }, 80);
    } catch (error) {
      console.error("Error removing cart item and related gifts:", error);
      this.updateCart();
    } finally {
      this.isGiftSyncing = false;
      this.isCartUpdating = false;
    }
  }

  toggleEmptyCartView(isEmpty) {
    this.classList.toggle("is-empty", isEmpty);

    const cartDrawerItems = this.querySelector("cart-drawer-items");
    if (cartDrawerItems) {
      cartDrawerItems.classList.toggle("is-empty", isEmpty);
    }

    const customHeader = this.querySelector(".custom-header");
    if (customHeader) {
      customHeader.style.display = isEmpty ? "none" : "";
    }

    const drawerFooter = this.querySelector(".drawer__footer");
    if (drawerFooter) {
      drawerFooter.style.display = isEmpty ? "none" : "";
    }
  }

  updateCart() {
    this.isCartUpdating = true;

    fetch(`${routes.cart_url}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.text();
      })
      .then((cartDrawerHtml) => {
        const cartDrawerFragment = document.createElement("div");
        cartDrawerFragment.innerHTML = cartDrawerHtml;

        const newCartDrawer = cartDrawerFragment.querySelector("cart-drawer");
        const newCartDrawerItems = cartDrawerFragment.querySelector("cart-drawer-items");

        const isEmptyCart = Boolean(
          newCartDrawer?.classList.contains("is-empty") ||
          newCartDrawerItems?.classList.contains("is-empty")
        );

        const sectionsToReplace = this.getSectionsToRender();

        sectionsToReplace.forEach((section) => {
          const sectionElement = document.querySelector(section.selector);
          const newSectionElement = cartDrawerFragment.querySelector(
            section.selector
          );

          if (sectionElement && newSectionElement) {
            sectionElement.innerHTML = newSectionElement.innerHTML;
          } else {
            console.warn(
              `Section element not found for selector: ${section.selector}`
            );
          }
        });

        const cartFooterElement = document.querySelector(".cart-drawer__footer");
        const newCartFooterElement = cartDrawerFragment.querySelector(".cart-drawer__footer");

        if (cartFooterElement && newCartFooterElement) {
          cartFooterElement.innerHTML = newCartFooterElement.innerHTML;
        } else {
          console.warn("Cart footer element not found");
        }

        this.toggleEmptyCartView(isEmptyCart);

        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      })
      .finally(() => {
        this.isCartUpdating = false;

        if (!this.isGiftSyncing) {
          this.syncFreeGiftsDebounced();
        }
      });
  }

  addProductToCart(productId, variantId, isUpsell = false) {
    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }

    if (this.isCartUpdating) {
      console.warn("Cart is currently being updated. Please try again later.");
      return;
    }

    const itemData = {
      items: [
        {
          id: variantId ? variantId : productId,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(itemData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            "Failed to add product to cart: " + response.statusText
          );
        }
        return response.json();
      })
      .then((data) => {
        this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));
        if (isUpsell) {
          this.updateCart(); // Only update cart when an upsell is added
        }
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  getNormalizedRuleList(values) {
    return (values || []).map(normalizeGiftRuleValue).filter(Boolean);
  }

  getNumericRuleList(values) {
    return (values || [])
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value) && value > 0);
  }

  isMainCartItem(item) {
    const itemHandle = getCartItemHandle(item);
    const productId = Number(item.product_id);
    const variantId = Number(item.variant_id);

    return (
      this.getNormalizedRuleList(FREE_GIFT_RULES.mainProductHandles).includes(itemHandle) ||
      this.getNumericRuleList(FREE_GIFT_RULES.mainProductIds).includes(productId) ||
      this.getNumericRuleList(FREE_GIFT_RULES.mainVariantIds).includes(variantId)
    );
  }

  isGiftCartItem(item) {
    const itemHandle = getCartItemHandle(item);
    const productId = Number(item.product_id);
    const variantId = Number(item.variant_id);

    return (
      this.getNormalizedRuleList(FREE_GIFT_RULES.giftProductHandles).includes(itemHandle) ||
      this.getNumericRuleList(FREE_GIFT_RULES.giftProductIds).includes(productId) ||
      this.getNumericRuleList(FREE_GIFT_RULES.giftVariantIds).includes(variantId)
    );
  }

  async syncFreeGiftsWithMainProduct() {
    if (this.isGiftSyncing) return;

    const hasGiftRule =
      (FREE_GIFT_RULES.giftProductHandles || []).length ||
      (FREE_GIFT_RULES.giftProductIds || []).length ||
      (FREE_GIFT_RULES.giftVariantIds || []).length;

    const hasMainRule =
      (FREE_GIFT_RULES.mainProductHandles || []).length ||
      (FREE_GIFT_RULES.mainProductIds || []).length ||
      (FREE_GIFT_RULES.mainVariantIds || []).length;

    if (!hasGiftRule || !hasMainRule) return;

    const rows = this.getCartItemRows();

    if (!rows.length) return;

    const hasMainProductInDom = rows.some((row) => this.isMainCartRow(row));
    const giftRowsToRemove = rows.filter((row) => this.isGiftCartRow(row));

    if (hasMainProductInDom || !giftRowsToRemove.length) return;

    this.isGiftSyncing = true;

    const updates = {};

    giftRowsToRemove.forEach((row) => {
      const item = this.getCartItemDataFromRow(row);
      if (item?.key) {
        updates[item.key] = 0;
      }
    });

    this.removeRowsInstantly(giftRowsToRemove);

    const remainingRows = rows.filter((row) => !giftRowsToRemove.includes(row));

    if (remainingRows.length === 0) {
      this.showInstantEmptyCartView();
    }

    try {
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (!updateResponse.ok) {
        throw new Error("Failed to remove gift products from cart");
      }

      this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));

      setTimeout(() => {
        this.updateCart();
      }, 80);
    } catch (error) {
      console.error("Error syncing free gifts with main product:", error);
      this.updateCart();
    } finally {
      this.isGiftSyncing = false;
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.querySelector("#CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
        this.syncFreeGiftsDebounced();
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");

    this.toggleEmptyCartView(false);
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));
    this.initializeUpsellButtons();
    this.initializeVariantSelectors();
    this.syncFreeGiftsDebounced();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-drawer",
        selector: ".cart-drawer__footer",
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);
